require('./assets/css/main.scss');

jQuery(document).ready(function($){
  const contactFlyoutButton = $('#contact-flyout-button');
  const flyoutWrapper = $('#flyout-wrapper');

  /**
   * Toggle the display of the flyout
   */
  contactFlyoutButton.on('click',function(e){
    flyoutWrapper.toggleClass('mod--open');
    if(flyoutWrapper.hasClass('mod--open')){
      $('.underpin-contact-flyout-drawer-content .ginput_container input:first').focus();
    }
    else{
      $('.underpin-contact-flyout-drawer-content .ginput_container input:first').blur();
    }
  });

  /**
   * Handle Gravity Forms Non-AJAX Submission
   */
  if($('#flyout-wrapper .gform_confirmation_wrapper').length){
    flyoutWrapper.addClass('mod--submitted')
  }

  /**
   * Handle Gravity Forms AJAX Submission
   */
  $(this).bind('gform_post_render', function($){
    flyoutWrapper.addClass('mod--submitted')
  });
});


// WEBPACK FOOTER //
// /Users/brockduncan/Sites/zonedcomfort/wp-content/mu-plugins/vendor/underpin/contact-flyout/index.js